module.exports = __webpack_public_path__ + "static/media/imaginelab.6e45959a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Achievements/imaginelab.png
// module id = 355
// module chunks = 0